import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import DashboardOperador from './DashboardOperador';

export default function Dashboard() {
  const { user } = useAuth();
  if (user.perfil === 'cliente' || user.perfil === 'auditor_hospital') {
    return <Navigate to={`/hospitais/${user.id_hospital}`} replace />;
  }
  return <DashboardOperador />;
}
